import { useContext } from 'react'
import ModalContext from './ContextModal'

export const useResultModal = () => {
  return useContext(ModalContext)
}